import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup'
import { Autocomplete, Box, Button, Grid, TextField } from "@mui/material";
import Header from "components/Header";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { BasePathProvider, useBasePath } from "components/Providers";
import { transferAsset } from "store/asset/asset-assign";
import { Controller, useForm } from "react-hook-form";

export default function TransferAsset({ asset }) {
    // const { id } = useParams()
    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const basePath = useBasePath()
    const campus = useSelector(state => state.lookup.campus?.filter(c => ['provider', 'school'].includes(c.type)))
    
    const schema = yup.object().shape({
        receivingCampusId: yup.number().required(t('Required')),
    })

    const { control, handleSubmit, formState } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
        }
    })

    const onSubmit = (data) => {
        const payload = {
            receivingCampusId: data.receivingCampusId,
            assetId: asset?.id,
            action: 'transfer'
        }

        dispatch(transferAsset(payload)).then((res) => {
            if (res.payload) {
                navigate(basePath)
            }
        })
    }

    return (
        <BasePathProvider value={`${basePath}`}>
            <Box>
                <Header title={t('Transfer Asset')} small close="." borderBottom />
            </Box>
            <Box data-component="AssgnAssetForm" component="form" onSubmit={handleSubmit(onSubmit)} py={2} px={1} >
                <Grid container spacing={1.5}>
                    <Grid item xs={12}>
                        <Controller
                            name="receivingCampusId"
                            control={control}
                            render={({ field }) => (
                                <Autocomplete
                                    {...field}
                                    value={campus.find(option => option.id === field.value) ?? null}
                                    options={campus}
                                    getOptionLabel={(option) => option.name || ''}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={t('Transfer To')}
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            error={!!formState.errors.receivingCampusId}
                                            helperText={formState.errors.receivingCampusId ? formState.errors.receivingCampusId.message : ''}
                                        />
                                    )}
                                    onChange={(event, newValue) => {
                                        field.onChange(newValue ? newValue.id : null)
                                    }}
                                    onBlur={() => {
                                        field.onBlur()
                                    }}
                                    isOptionDisabled={(option) => option.disabled}
                                    noOptionsText={t('No options')}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
                <Box display="flex" justifyContent="flex-end" gap={1} mt={2}>

                    <Button
                        type="submit"
                        size="small"
                        variant="contained"
                        color="primary"
                        disabled={!formState.isDirty}
                    >
                        {t('Save')}
                    </Button>
                </Box>
            </Box>
        </BasePathProvider>
    );
}